import { html } from "lit";

export default html`
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
    <path
      fill="currentColor"
      fill-rule="evenodd"
      d="M18.209 4.942a9.364 9.364 0 0 0-6.21-2.342A9.4 9.4 0 0 0 2.6 12c0 2.38.885 4.553 2.343 6.21L18.21 4.941Zm.849.849L5.79 19.058A9.364 9.364 0 0 0 12 21.4a9.4 9.4 0 0 0 9.4-9.4c0-2.38-.884-4.553-2.342-6.21ZM12 1.4c5.854 0 10.6 4.746 10.6 10.6 0 5.854-4.746 10.6-10.6 10.6-5.854 0-10.6-4.746-10.6-10.6C1.4 6.146 6.146 1.4 12 1.4Z"
      clip-rule="evenodd"
    />
  </svg>
`;
